module.exports = __webpack_public_path__ + "img/balanco_active.38054ff5.png";